<!--
	SEVEN GRID ROWS, in this order: head (the card's own header), subtitle,
	price, price-note, dial, button, features. The plans grid spans the card
	over exactly those seven rows, so the dials and the buttons line up across
	cards because they share a row rather than because a min-height happened to
	match. An eighth child falls outside the span and lands on top of what
	follows it. See the class comment before changing this.
-->
<lo-card [heading]="title" [headingLevel]="2">
	@if (popular) {
	<lo-status loCardActions tone="info" data-testid="plan-recommended">
		{{ popularLabel }}
	</lo-status>
	} @if (hasTrial) {
	<lo-status
		loCardActions
		[tone]="trialKind === 'app' ? 'success' : 'info'"
		[attr.data-kind]="trialKind"
	>
		Free trial
	</lo-status>
	}

	<p class="plan-sub lo-type-text-sm">{{ subtitle }}</p>

	<div class="plan-price">
		@if (struckPrice) {
		<span class="price-struck lo-type-text-lg-semibold">
			{{ struckPrice }}
		</span>
		}
		<span class="price-value lo-type-display">${{ priceFigure }}</span>
		<span class="price-meta lo-type-text-sm-semibold">{{ priceMeta }}</span>
	</div>

	<p class="price-note lo-type-text-sm-medium">{{ priceNote }}</p>

	<div class="plan-dial">
		@if (ladderSelectable) {
		<app-plan-ladder-select
			[label]="ladderLabel"
			[stops]="ladder"
			[index]="ladderClampedIndex"
			[footerNote]="ladderFooter"
			(indexChange)="onLadderSelected($event)"
		></app-plan-ladder-select>
		} @else {
		<span class="dial-label lo-type-label-caps">{{ ladderLabel }}</span>
		<span class="dial-static lo-type-text-md-semibold">
			{{ ladderStaticLabel }}
		</span>
		} @if (actionNote) {
		<p
			class="action-note lo-type-text-sm-medium"
			data-testid="plan-action-note"
		>
			{{ actionNote }}
		</p>
		}
	</div>

	<button
		lo-button
		type="button"
		block
		[variant]="actionVariant"
		[attr.data-action]="actionType"
		[disabled]="actionDisabled"
		(click)="onAction()"
	>
		@if (leadingCheck) {
		<lo-icon name="check"></lo-icon>
		}
		{{ actionLabel }}
	</button>

	<div class="plan-body">
		@if (featureRows.length > 0) {
		<dl class="plan-limits lo-type-text-sm">
			@for (row of featureRows; track row.label) {
			<div class="row">
				<dt>{{ row.label }}</dt>
				<dd>
					@if (row.value === 'On') {
					<lo-status tone="success">On</lo-status>
					} @else if (row.value === 'Off') {
					<lo-status tone="neutral">Off</lo-status>
					} @else {
					<span class="lo-type-text-sm-semibold">
						{{ row.value }}
					</span>
					}
				</dd>
			</div>
			}
		</dl>
		} @if (detailsAvailable) {
		<button
			lo-button
			variant="link"
			size="sm"
			type="button"
			data-testid="plan-details-link"
			(click)="onDetails()"
		>
			See everything included
			<lo-icon name="small_arrow_right" [size]="12"></lo-icon>
		</button>
		}
	</div>
</lo-card>
